export enum CarouselTypes {
    lightbox = 'lightbox',
    gallery = 'gallery',
}
